const reportWebsiteIssueForm = () => ({
    ...window.helpers,
    bug: '',
    email: '',
    fieldKeys: ['bug', 'email'],
    submitForm() {
        const action = '/api/reportwebsiteissue'

        this.initAndExecuteGoogleCaptcha(action).then((token) => {
            const formData = new FormData()

            formData.append('captcha_token', token)
            formData.append('captcha_action', action)
            formData.append('bug', this.bug)
            formData.append('email', this.email)

            this.submitting = true
            this.errors = {}

            window.api.post(action, formData).then((response) => {
                if (response.data.success === true) {
                    this.submitting = false
                    this.successfulSubmission = true
                    this.bug = ''
                    this.email = ''
                    this.errors = {}
                } else {
                    this.processServersideErrors(response.data)
                }
            }).catch((error) => {
                this.submitting = false
                this.successfulSubmission = false
                this.processServersideErrors(error.response.data)
            })
        })
    },
})
document.addEventListener('alpine:init', () => {
    window.Alpine.data('reportWebsiteIssueForm', reportWebsiteIssueForm)
})
